import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FaUser, FaEnvelope, FaEdit, FaShoppingBag, FaCrown, FaSignOutAlt, FaCog } from 'react-icons/fa';

const ProfilePage = () => {
  const { currentUser, logout } = useAuth();
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState({
    name: currentUser?.name || '',
    email: currentUser?.email || '',
  });
  
  // In a real app, this would save changes to the backend
  const handleSaveChanges = (e) => {
    e.preventDefault();
    // Implement API call to update user profile
    setEditMode(false);
  };
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };
  
  const handleLogout = () => {
    logout();
  };

  return (
    <div style={{ background: '#f6f8fa', minHeight: '100vh', padding: '2.5rem 0' }}>
      <div className="container">
        <h1 className="text-3xl font-bold mb-6" style={{ letterSpacing: 1 }}>My Account</h1>
        <div className="row g-4">
          {/* Profile Card */}
          <div className="col-12 col-lg-4">
            <div style={{
              background: '#fff',
              borderRadius: 24,
              boxShadow: '0 8px 32px 0 rgba(31,38,135,0.10)',
              padding: '2.5rem 2rem',
              marginBottom: 24,
              textAlign: 'center',
              position: 'relative',
            }}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 18 }}>
                <div style={{
                  background: 'linear-gradient(135deg, #4f46e5 0%, #06b6d4 100%)',
                  color: 'white',
                  borderRadius: '50%',
                  width: 72,
                  height: 72,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 36,
                  fontWeight: 700,
                  marginBottom: 10,
                  boxShadow: '0 2px 8px rgba(31,38,135,0.10)'
                }}>
                  {currentUser?.name ? currentUser.name[0].toUpperCase() : <FaUser />}
                </div>
                <div style={{ fontWeight: 700, fontSize: 22 }}>{currentUser?.name}</div>
                <div style={{ color: '#4f46e5', fontWeight: 500, fontSize: 15, marginBottom: 4 }}>
                  <FaEnvelope style={{ marginRight: 6 }} /> {currentUser?.email}
                </div>
                {currentUser?.isAdmin && (
                  <div style={{ marginTop: 8 }}>
                    <span style={{ background: '#06b6d4', color: 'white', borderRadius: 12, padding: '2px 14px', fontWeight: 600, fontSize: 14, display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                      <FaCrown style={{ marginRight: 4 }} /> Admin
                    </span>
                  </div>
                )}
              </div>
              {currentUser?.isAdmin && (
                <Link to="/admin" style={{
                  display: 'inline-block',
                  background: '#4f46e5',
                  color: 'white',
                  borderRadius: 16,
                  padding: '8px 24px',
                  fontWeight: 600,
                  fontSize: 16,
                  marginBottom: 10,
                  textDecoration: 'none',
                  marginTop: 8,
                  boxShadow: '0 2px 8px 0 rgba(31, 38, 135, 0.10)',
                  transition: 'background 0.2s',
                }}>
                  <FaCog style={{ marginRight: 8 }} /> Go to Admin Dashboard
                </Link>
              )}
            </div>
          </div>
          {/* Account Settings & Orders */}
          <div className="col-12 col-lg-8">
            <div style={{
              background: '#fff',
              borderRadius: 24,
              boxShadow: '0 8px 32px 0 rgba(31,38,135,0.10)',
              padding: '2.5rem 2rem',
              marginBottom: 24,
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 18 }}>
                <h2 style={{ fontWeight: 700, fontSize: 22, margin: 0 }}>Account Settings</h2>
                <button
                  onClick={() => setEditMode(!editMode)}
                  style={{
                    background: '#e0e7ff',
                    color: '#4f46e5',
                    border: 'none',
                    borderRadius: 8,
                    padding: '8px 18px',
                    fontWeight: 600,
                    fontSize: 15,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    cursor: 'pointer',
                  }}
                >
                  <FaEdit /> {editMode ? 'Cancel' : 'Edit Profile'}
                </button>
              </div>
              {editMode ? (
                <form onSubmit={handleSaveChanges}>
                  <div className="form-group mb-3">
                    <label className="form-label">Full Name</label>
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      style={{ borderRadius: 10, background: '#f8fafc', border: '1.5px solid #e0e7ef' }}
                    />
                  </div>
                  <div className="form-group mb-3">
                    <label className="form-label">Email</label>
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      style={{ borderRadius: 10, background: '#f8fafc', border: '1.5px solid #e0e7ef' }}
                    />
                  </div>
                  <div style={{ display: 'flex', gap: 12, marginTop: 18 }}>
                    <button type="submit" className="btn btn-primary" style={{ borderRadius: 10, fontWeight: 600, fontSize: 16 }}>
                      Save Changes
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      style={{ borderRadius: 10, fontWeight: 600, fontSize: 16 }}
                      onClick={() => setEditMode(false)}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              ) : (
                <ul style={{ listStyle: 'none', padding: 0, margin: 0, fontSize: 17 }}>
                  <li style={{ marginBottom: 18, display: 'flex', alignItems: 'center', gap: 10 }}>
                    <FaUser style={{ color: '#4f46e5' }} /> Profile Information
                  </li>
                  <li style={{ marginBottom: 18 }}>
                    <Link to="/orders" style={{ color: '#4f46e5', fontWeight: 600, textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 10 }}>
                      <FaShoppingBag /> My Orders
                    </Link>
                  </li>
                  <li>
                    <button
                      onClick={handleLogout}
                      style={{
                        background: '#fff',
                        color: '#e11d48',
                        border: '1.5px solid #e0e7ef',
                        borderRadius: 10,
                        padding: '8px 18px',
                        fontWeight: 600,
                        fontSize: 16,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 8,
                        cursor: 'pointer',
                        marginTop: 6,
                        boxShadow: '0 2px 8px 0 rgba(31,38,135,0.04)'
                      }}
                    >
                      <FaSignOutAlt /> Logout
                    </button>
                  </li>
                </ul>
              )}
            </div>
            <div style={{
              background: '#fff',
              borderRadius: 24,
              boxShadow: '0 8px 32px 0 rgba(31,38,135,0.10)',
              padding: '2.5rem 2rem',
              marginTop: 24,
            }}>
              <h2 style={{ fontWeight: 700, fontSize: 22, marginBottom: 18 }}>Recent Orders</h2>
              <Link to="/orders" style={{ color: '#4f46e5', fontWeight: 600, textDecoration: 'none', fontSize: 16 }}>
                View all orders
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage; 